import {useMemo} from 'react';

import {SearchBar, Select} from '@/components';
import {getAdminRoleOptions} from '@/constants/formatters';
import {AfriexRoles} from '@/types';
import type {AdminFiltersProps} from '@/types/AfriexAdmin';

const AdminFilters = ({
  currentFilters,
  clearFilters,
  selectCurrentFilters,
  handleAutoComplete,
}: AdminFiltersProps) => {
  const adminRoleOptions = useMemo(
    () => getAdminRoleOptions([AfriexRoles.USER]),
    [],
  );
  return (
    <>
      <div className="mt-5 w-full">
        <div className="flex flex-col lg:flex-row lg:items-center justify-between">
          {/* Left Side if needed */}
          <div className="flex items-center space-x-3 w-full md:w-3/5">
            <SearchBar
              handleSearch={handleAutoComplete}
              handleAutoComplete={handleAutoComplete}
              clearFilters={clearFilters}
              placeholder="Search By Afriex Email"
              inputClassName="w-full"
            />
          </div>

          <div className="flex md:items-center mt-3 md:mt-3">
            <Select
              onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
                selectCurrentFilters('roles', e.target.value)
              }
              value={currentFilters.roles}
              name="roles"
              options={adminRoleOptions}
              placeholder="Filter by Role"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminFilters;
